import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import RentalTerms from './RentalTerms';

const date = value => value ? new Date(value).toLocaleDateString('ru-RU') : 'Не сохранено';
const money = value => Number(value).toLocaleString('ru-RU', { style: 'currency', currency: 'RUB' });

// Presentation is shared by the cabinet and ERP; loading/auth stays in each boundary.
export default function ExtensionDocuments({ documents = [] }) {
  return <Box component="section" aria-label="История продлений" sx={{ my: 2, width: '100%' }}>
    <Typography variant="h6">История продлений</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      Исходный принятый договор сохраняется. Изменения срока и стоимости показаны отдельно.
    </Typography>
    {!documents.length && <Typography variant="body2">Оплаченных продлений пока нет.</Typography>}
    {documents.map((doc, index) => <Box key={doc.id} component="details" sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 1.5, mb: 1 }}>
      <summary>Продление №{index + 1} · {doc.id}{!doc.unavailable && ` · до ${date(doc.new_end_date)}`}</summary>
      <ExtensionDocumentDetails doc={doc} />
    </Box>)}
  </Box>;
}

export function ExtensionDocumentDetails({ doc, formatDate = date }) {
  return <>
      {doc.unavailable ? <Alert severity="warning" sx={{ mt: 1 }}>Сохранённое подтверждение недоступно. Обратитесь к сотруднику для сверки.</Alert> : <>
        <Typography variant="body2" sx={{ mt: 1 }}>Договор №{doc.deal_number}</Typography>
        <Typography variant="body2">Окончание аренды: {formatDate(doc.previous_end_date)} → {formatDate(doc.new_end_date)}</Typography>
        <Typography variant="body2">Стоимость продления: {money(doc.amount)}</Typography>
        <Typography variant="body2">Сумма аренды после продления: {money(doc.total_amount)}</Typography>
        <Typography variant="body2">Запись об оплате: {doc.paid_at ? new Date(doc.paid_at).toLocaleString('ru-RU') : '—'}</Typography>
        {doc.items.map(item => <Typography key={item.asset_id} variant="body2" sx={{ mt: 1 }}>
          {item.name}: {item.period_start ? `${formatDate(item.period_start)} — ` : 'до '}{formatDate(item.new_end_date)} · {money(item.amount)}
        </Typography>)}
        {doc.source === 'payment_history' && <Alert severity="info" sx={{ mt: 1 }}>
          Сведения из сохранённой истории оплаты. Отдельный текст условий продления тогда не сохранялся.
        </Alert>}
        <RentalTerms terms={doc.terms} />
        {doc.text && <Button component="a" download={`prokatprost-${doc.id}.txt`}
          href={`data:text/plain;charset=utf-8,${encodeURIComponent(doc.text)}`} sx={{ mt: 1 }}>Скачать подтверждение</Button>}
      </>}
      {doc.payment_cancelled && <Alert severity="warning" sx={{ mt: 1 }}>Платёж отменён сотрудником. Это архивная запись; текущий расчёт смотрите в заказе.</Alert>}
  </>;
}
